import { WebSocketSendActionDataMessage } from './web-socket-send-action-data-message';
import { BulkDeleteAssetsRequest } from '../../../../image/requests/bulk-delete-assets-request';
import { WebSocketMessageActionRequestType } from '../../../contexts/web-socket-message-context-action-request-type';

/**
 * {
 *     "action": "ACTION_REQUEST",
 *     "entityId": 420420,
 *     "payload": {
 *         "requestId": "asd123",
 *         "companyId": 170479,
 *         "locationId": 420420,
 *         "userId": "cedb0a50-c3da-4cc9-9442-61091c1cea34",
 *         "actionType": "WebsocketActionRequestType_BulkDeleteAssets",
 *         "metadata": {},
 *         "payload": {
 *             "assets": [
 *                 { "id": "170479", "md5Hash": "d6db14eb079c83f89971ab2f3e662a7b" }
 *             ],
 *             "assetFolderIds": ["1a5d1b1e-2c9f-4d3a-9f2a-1b8c6d4e5f70"],
 *             "targetFolderId": "",
 *             "deleteAllItems": true
 *         },
 *         "connectionId": "LZqERciJPHcCJXA=",
 *         "entityId": 420420
 *     }
 * }
 *
 * companyId is required in practice - the API scopes the job to it and, unlike a data request, will not backfill it
 * from locationId. userId is sent for consistency only; the API resolves the acting user from the connection.
 */
export class WebSocketRequestBulkDeleteAssets extends WebSocketSendActionDataMessage {
  constructor(userId: string, companyId: number, locationId: number, request: BulkDeleteAssetsRequest) {
    super(locationId);
    this.payload.companyId = companyId;
    this.payload.locationId = locationId;
    this.payload.userId = userId;
    this.payload.actionType = WebSocketMessageActionRequestType.BulkDeleteAssets;
    this.payload.metadata = {};
    this.payload.payload = request;
  }
}
